import React, { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import WarningAmberSharpIcon from '@mui/icons-material/WarningAmberSharp';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
import { Portal } from "../components/Portal";


const WarningToast = ({ show, message, onClose }) => {
  const toastRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (show) {
      const toastElement = toastRef.current;
      const bootstrapToast = new Toast(toastElement);
      //   const bootstrapToast = new Toast(toastElement, { autohide: false });
      bootstrapToast.show();

      toastElement.addEventListener("hidden.bs.toast", onClose);
      return () => {
        toastElement.removeEventListener("hidden.bs.toast", onClose);
      };
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <Portal layer="toast">
      <div className="wlj-app-toast">
        <div
          className="toast fade no-border-radius"
          ref={toastRef}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-header text-white">
            <WarningAmberSharpIcon className="material-symbols-sharp me-2" />
            <strong className="me-auto">{t("modals.Warning")}</strong>
            {/* <button
              type="button"
              className="btn-close"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button> */}
             <CloseSharpIcon
                style={{ fontSize: "18px", fontWeight: "600", color
                  : "black"
                 }}
                className="pointer"
                onClick={() => {
                  const bootstrapToast = Toast.getInstance(toastRef.current);
                  if (bootstrapToast) {
                    bootstrapToast.hide(); 
                  }
                  onClose(); 
                }}
              />
          </div>

          <div className="toast-body text-white">{message}</div>
        </div>
      </div>
    </Portal>
  );
};

export default WarningToast;
